import { RefObject } from "react";

export const scrollToId = (
  elementId: string,
  scrollOptions?: ScrollIntoViewOptions,
) => {
  const element = document.getElementById(elementId);
  element &&
    element.scrollIntoView({
      behavior: "smooth",
      ...scrollOptions,
    });
};

export const scrollToRef = (ref: RefObject<HTMLElement>) => {
  const supportsNativeSmoothScroll =
    "scrollBehavior" in document.documentElement.style;

  if (supportsNativeSmoothScroll) {
    ref &&
      ref.current &&
      window &&
      window.scrollTo({ behavior: "smooth", top: ref.current.offsetTop });
  } else {
    ref && ref.current && window && window.scrollTo(0, ref.current.offsetTop);
  }
};
